export default __webpack_public_path__ + "static/apple.url-fda02e7790bd4c6de1d757ef1a2c7b98.svg";